import { _ as _extends } from '../../../extends-30811c5e.js';
import React__default from 'react';
import classNames from 'classnames';
import { getPrefixCls } from '../../../utils/getPrefix.js';
import { Modal } from '../ModalBase.js';
import '../../../defineProperty-6f298737.js';
import 'react-dom';
import '../../Icon/IconCrossSmall.js';
import '../../../objectWithoutProperties-dd908bcc.js';

function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}

var prefixCls = getPrefixCls('modal');
function Custom(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React__default.createElement(Modal, _extends({}, props, {
    className: classNames("".concat(prefixCls, "-custom"), props.className)
  }), props.children);
}

export { Custom };
